export const ERROR_SYNC_COMPARE = "Ошибка при синхронизации сравнений";